import {
  AgStepbarItem,
  AgDropMenu,
  AgDropMenuContent
} from '@rededor/ag-shared-components-react'
import { useStepStatus } from '@/hooks/useStepStatus'
import { useStepAction } from './useStepAction'
import { useScheduleStore } from '@/store/useScheduleStore'
import { format } from 'date-fns'
import { Show } from '@/components/Show'

export const ScheduleStep = () => {
  const slot = useScheduleStore((state) => state.slot)
  const targetStep = 'schedule'

  const status = useStepStatus({
    isCompleted: Boolean(slot?.id),
    targetPath: '/agendar-consulta',
    targetStep
  })

  const slotFormatted = slot?.start
    ? format(slot?.start, "dd/MM/yyyy' - Horário: 'HH:mm'h")
    : undefined

  const { handleClickAction, handleSelectStep } =
    useStepAction('/agendar-consulta')

  return (
    <AgStepbarItem
      step="Agenda"
      info={slotFormatted}
      icon="calendar"
      onSelectStep={handleSelectStep}
      status={status}
      targetStep={targetStep}
    >
      <Show when={status !== 'error'}>
        <AgDropMenu>
          <AgDropMenuContent
            step="Agenda"
            info={slotFormatted}
            labelAction="Alterar dia e horário"
            onClickAction={handleClickAction}
          />
        </AgDropMenu>
      </Show>
    </AgStepbarItem>
  )
}
